import { AdminApiService } from '../services';

export type GetWebhooksFilters = {
  contactId?: string | null;
  campaignId?: string | null;
  eventType?: string | null;
  processed?: string | null;
};

export const getWebhooks = (
  filters: GetWebhooksFilters,
  page: ApiPaginationType
) => {
  return AdminApiService.getWebhookEventsApiAdminWebhookEventsGet(
    filters?.contactId,
    filters?.campaignId,
    filters?.eventType,
    filters?.processed,
    page?.limit,
    page?.offset
  );
};

export type { WebhookEventResponse as WebhookItem } from '../services';
